var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWazdan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 8,
    viewBox: "0 0 74 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00057 7.87105L0.753912 0.735523C0.480316 0.463283 0.674012 0 1.06383 0H8.31051C8.55263 0 8.74632 0.193433 8.74632 0.429849V7.56775C8.74632 7.94984 8.2766 8.14329 8.00057 7.87105Z",
    fill: "rgba(var(--provider-icon-color))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61951 7.56775V0.429849C9.61951 0.191045 9.81563 0 10.0553 0H17.302C17.6918 0 17.8855 0.463283 17.6119 0.735523L10.3652 7.87345C10.0892 8.14329 9.61951 7.95225 9.61951 7.57016",
    fill: "rgba(var(--provider-icon-color))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5006 7.56775V0.429849C18.5006 0.191045 18.6967 0 18.9364 0H26.1831C26.5729 0 26.7666 0.463283 26.493 0.735523L19.2463 7.87345C18.9703 8.14329 18.5006 7.95225 18.5006 7.57016",
    fill: "rgba(var(--provider-icon-color))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5652 0V4.92655L34.8222 1.43761H33.8222L32.0569 4.9624V0H30.4808V8H32.0449L34.304 3.63942L36.5871 8H38.1295V0H36.5652Z",
    fill: "rgba(var(--provider-icon-color))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4996 2.29493L43.4172 5.11283H41.5821L42.4996 2.29493ZM41.7128 0L38.8895 7.9976H40.6547L41.1485 6.4788H43.8676L44.3615 7.9976H46.1144L43.2889 0H41.7128Z",
    fill: "rgba(var(--provider-icon-color))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4367 0V1.3803H49.7318L46.4367 6.93252V8H51.9207V6.63163H48.5309L51.8044 1.06746V0H46.4367Z",
    fill: "rgba(var(--provider-icon-color))"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.349 4.52059V3.47702C57.349 2.09672 56.9712 1.37791 55.877 1.37791H54.6398V6.63163H55.877C56.9712 6.63163 57.349 5.90089 57.349 4.52059ZM52.9933 7.9976V0H55.877C57.7121 0 58.9955 0.926566 58.9955 3.47702V4.52059C58.9955 7.05911 57.7121 7.9976 55.877 7.9976H52.9933Z",
    fill: "rgba(var(--provider-icon-color))"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8837 2.29493L63.8015 5.11283H61.9661L62.8837 2.29493ZM62.0969 0L59.2738 7.9976H61.0387L61.5329 6.4788H64.2517L64.7458 7.9976H66.4987L63.6732 0H62.0969Z",
    fill: "rgba(var(--provider-icon-color))"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8107 0V5.01969L68.6317 0H67.2661V8H68.8326V3.04955L71.9997 8H73.3747V0H71.8107Z",
    fill: "rgba(var(--provider-icon-color))"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWazdan);
export default __webpack_public_path__ + "static/media/wazdan.34b39ffd7ccaf980ea0719f8f063b60a.svg";
export { ForwardRef as ReactComponent };